














import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { modifyBindInfo } from '@/api/school';
@Component({})
export default class ManageDialog extends Vue {
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;

  @Prop({
    type: Array,
    default() {
      return []
    }
  })
  list!: any[];
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getActivationList!: Function;

  private dialogVisible = false;
  // 解绑
  private unbundle(row: any) {
    this.$confirm("确定解绑该设备吗?", "确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true
      }).then(async () => {
        try {
          // modifyType 2 解绑
          let opt = { modifyType: 2, id: row.id, activationCode: row.activationCode}
          await modifyBindInfo(opt);
          let params = { activationId: row.activationId }
          await this.getData(params)
          this.dialogVisible = false
          this.$message.success('解绑设备成功');
        } catch (err) {
            this.$message.error(err.message);
        }
      })
        .catch(err => {})
  }
  private handleClose() {
    this.dialogVisible = false;
  }
}
